module.exports = __webpack_public_path__ + "static/media/mavim.a4083efd.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/mavim.webp
// module id = 536
// module chunks = 0